import { Directive, ElementRef, Renderer2, AfterViewInit, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Directive({
  selector: '[appCheckUtf8]',
  standalone: true,
})
export class CheckUtf8Directive implements OnInit, AfterViewInit {
  constructor(private el: ElementRef, private renderer: Renderer2, private translateService: TranslateService) {}

  ngOnInit(): void {
    this.translateService.onLangChange.subscribe(() => {
      this.doCheck();
    });
  }

  ngAfterViewInit(): void {
    this.doCheck();
  }

  public get elementAccessor() {
    return this.el.nativeElement;
  }

  public doCheck() {
    // Get the text content of the element
    setTimeout(
      (_this) => {
        const text = _this.el.nativeElement.textContent;

        if (_this.containsNonAscii(text)) {
          // Remove any existing language-specific classes
          _this.renderer.removeClass(_this.el.nativeElement, 'custom-jp');
          _this.renderer.removeClass(_this.el.nativeElement, 'custom-cyrillic');
          
          // Add appropriate class based on detected language
          if (_this.containsCyrillic(text) || _this.containsSerbianLatin(text)) {
            _this.renderer.addClass(_this.el.nativeElement, 'custom-cyrillic');
          } else if (_this.containsJapanese(text)) {
            _this.renderer.addClass(_this.el.nativeElement, 'custom-jp');
          } else {
            // Fallback for other non-ASCII characters
            _this.renderer.addClass(_this.el.nativeElement, 'custom-jp');
          }
        } else {
          _this.renderer.removeClass(_this.el.nativeElement, 'custom-jp');
          _this.renderer.removeClass(_this.el.nativeElement, 'custom-cyrillic');
        }
      },
      500,
      this
    );
  }

  containsNonAscii(text: string): boolean {
    // Check if any character in the string has a character code greater than 127 (non-ASCII)
    // but exclude ASCII punctuation characters
    const asciiPunctuation = [',', '.', '(', ')', ';', ':', '!', '?', '-', '+','/','%','*'];
    
    for (let i = 0; i < text.length; i++) {
      const charCode = text.charCodeAt(i);
      const char = text.charAt(i);
      
      if (charCode > 127) {
        return true;
      } 
      // else if (asciiPunctuation.includes(char)) {
      //   // Return false for ASCII punctuation characters
      //   return false;
      // }
    }
    return false;
  }

  containsCyrillic(text: string): boolean {
    // Check for Cyrillic characters (U+0400-U+04FF)
    const cyrillicRegex = /[\u0400-\u04FF]/;
    return cyrillicRegex.test(text);
  }

  containsSerbianLatin(text: string): boolean {
    // Check for Serbian Latin characters (Š, Č, Ć, Ž and their lowercase versions)
    const serbianLatinRegex = /[ŠČĆŽščćž]/;
    return serbianLatinRegex.test(text);
  }

  containsJapanese(text: string): boolean {
    // Check for Japanese characters (Hiragana, Katakana, Kanji)
    const japaneseRegex = /[\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FBF]/;
    return japaneseRegex.test(text);
  }
}
